import React, { useState } from "react";
import { useAuth } from "hooks/authHooks";
import _isEmpty from "lodash/isEmpty";
import styles from "./HeroBanner.module.scss";
import AphButton from "components/web-ui-components/AphButton";
import MenuItem from "@material-ui/core/MenuItem";
import AphSelect from "components/web-ui-components/AphSelect";
import {
  getPatientAttributes,
  getPatientDetails,
} from "../../helpers/commonHelpers";
import { GenerateIcon } from "helpers/iconGenerator";
import { ICONS_PATHS } from "helpers/constants";
import { GetCurrentPatients_getCurrentPatients_patients } from "graphql/types/GetCurrentPatients";
import { eventTracking } from "../../clevertapTracking";
import { SignedinState } from "../enums/SignedinState";
import { MascotWithMessage } from "components/MascotWithMessage";
import AphDialog from "components/web-ui-components/AphDialog";
import AphDialogClose from "components/web-ui-components/AphDialogClose";
import AphDialogTitle from "components/web-ui-components/AphDialogTitle";
import { AddNewProfile } from "components/MyAccount/AddNewProfile/AddNewProfile";
import Popover from "@material-ui/core/Popover";
import dynamic from "next/dynamic";
const iconPathsCircle = ICONS_PATHS.slice(0, 3);

interface Props {
  isUserCare?: boolean;
}
type Patient = GetCurrentPatients_getCurrentPatients_patients;

const DynamicOurServices = dynamic(
  () =>
    import("components/OurServices/OurServices").then(
      (defaultComponent) => defaultComponent.default
    ),
  { ssr: false }
);

const HeroBanner: React.FC<Props> = (props) => {
  const { isUserCare } = props;
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);
  const [name, setName] = useState<string>("");

  const [
    isAddNewProfileDialogOpen,
    setIsAddNewProfileDialogOpen,
  ] = useState<boolean>(false);
  const [isMeClicked, setIsMeClicked] = useState<boolean>(false);
  //   const currentDevice = useMobileDetect();

  const {
    isSignedIn,
    allCurrentPatients,
    currentPatient,
    setCurrentPatientId,
  } = useAuth();
  const patientDetails = getPatientDetails(currentPatient);

  return (
    <div
      className={`${styles.bannerContainer} ${
        isSignedIn === SignedinState.SIGNEDIN ? styles.loginHeroBanner : ""
      }`}
    >
      <div className={styles.bannerContent}>
        {allCurrentPatients &&
        isSignedIn &&
        currentPatient &&
        !_isEmpty(currentPatient.firstName) ? (
          <div className={styles.welcomeMsg}>
            <h2>hi</h2>
            <div className={styles.welcomeUser}>
              <AphSelect
                value={currentPatient.id}
                onChange={(e) =>
                  setCurrentPatientId(e.target.value as Patient["id"])
                }
                classes={{
                  root: styles.selectMenuRoot,
                  selectMenu: styles.selectMenuItem,
                }}
                title={currentPatient.firstName || ""}
              >
                {allCurrentPatients.map((patient) => {
                  // const isSelected = patient.id === currentPatient.id;
                  const isSelected = patient.relation === "ME";
                  const name = (patient.firstName || "").toLocaleLowerCase();
                  return (
                    <MenuItem
                      selected={isSelected}
                      value={patient.id}
                      classes={{ selected: styles.menuSelected }}
                      key={patient.id}
                      title={name || ""}
                    >
                      {name}
                    </MenuItem>
                  );
                })}
                <MenuItem classes={{ selected: styles.menuSelected }}>
                  <AphButton
                    color="secondary"
                    className={styles.addMemberBtn}
                    onClick={() => {
                      setIsAddNewProfileDialogOpen(true);
                    }}
                    title={"Add Member"}
                  >
                    +Add Member
                  </AphButton>
                </MenuItem>
              </AphSelect>
              {isUserCare && (
                <div className={styles.circleLogo}>
                  <GenerateIcon
                    pathName={iconPathsCircle}
                    iconClass={"icon-circle"}
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <h2>hello there!</h2>
        )}

        <p> Always caring about your health, we are here to help you!</p>
        <DynamicOurServices />
      </div>
      <div
        className={`${styles.bannerImg} ${
          isSignedIn === SignedinState.SIGNEDIN ? styles.loginbannerImg : ""
        }`}
      >
        <img
          src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/img-doctors@1x.jpg`}
          alt="Online Doctor Consultation &amp; Medicines"
        />
      </div>
      <AphDialog open={isAddNewProfileDialogOpen} maxWidth="sm">
        <AphDialogClose
          onClick={() => {
            setIsAddNewProfileDialogOpen(false);
            window.location.reload();
          }}
          title={"Close"}
        />
        <AphDialogTitle className={styles.dialogTitle}>
          Add New Member
        </AphDialogTitle>
        <AddNewProfile
          closeHandler={(isAddNewProfileDialogOpen: boolean) =>
            setIsAddNewProfileDialogOpen(isAddNewProfileDialogOpen)
          }
          isMeClicked={isMeClicked}
          selectedPatientId={""}
          successHandler={(isPopoverOpen: boolean) =>
            setIsPopoverOpen(isPopoverOpen)
          }
          isProfileDelete={false}
        />
      </AphDialog>
      <Popover
        open={isPopoverOpen}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        classes={{ root: styles.popOver, paper: styles.bottomPopover }}
      >
        <MascotWithMessage
          messageTitle=""
          message="Profile created successfully."
          closeButtonLabel="OK"
          closeMascot={() => {
            setIsPopoverOpen(false);
            window?.location?.reload();
          }}
        />
      </Popover>
    </div>
  );
};

export default HeroBanner;
